import React from "react";
import Loader from "../../../components/Loader";
import NoData from "../../../components/NoData";
import moment from "moment";

const BalanceHistory = (props) => {
  const {
    userId,
    rows,
    loading,
    page,
    pagination,
    limit,
    setLimit,
    setPage,
    user,
    setDetailsOpen,
    setDetailsLoading,
    setDetails,
    openDetails,
  } = props;
  return (
    <div>
      {loading ? (
        <Loader message="Loading transactions..." />
      ) : rows.length === 0 ? (
        <NoData
          message="No Balance History Found"
          subText="Try changing date range or search keyword."
        />
      ) : (
        <>
          <div className="tx-table-bpl-scroll">
            <div className={`tx-table-header-bh`}>
              <div>Sr. No.</div>
              <div>Date</div>
              <div>Credit</div>
              <div>Debit</div>
              <div>Balance</div>
              <div style={{ minWidth: "210px" }}>Details</div>
            </div>

            <div className={`tx-table-bh`}>
              {rows.map((r, index) => (
                <div className={`tx-row-bh`} key={r.id}>
                  <div>{index + 1}</div>
                  <div>
                    <span>
                      {r.created_at
                        ? moment
                            .utc(r.created_at)
                            .local()
                            .format("DD/MM/YYYY hh:mm A")
                        : "—"}
                    </span>
                    <div className="tx-muted">{r.reference_type || "-"}</div>
                  </div>
                  <div>
                    {r.txn_type === "CREDIT" ? (
                      <span className="tx-amount-bh-credit">{`${r.amount}`}</span>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    {r.txn_type === "DEBIT" ? (
                      <span className="tx-amount-bh-debit">{`${r.amount}`}</span>
                    ) : (
                      "-"
                    )}
                  </div>
                  <div>
                    <div style={{ fontWeight: 700 }}>{r.balance_after}</div>
                    <div className="tx-muted">Before: {r.balance_before}</div>
                  </div>
                  <div style={{ minWidth: "210px" }}>{r.remark}</div>
                </div>
              ))}
            </div>
          </div>
          {pagination && pagination.totalPages > 1 && (
            <div className="modern-pagination">
              {/* Limit Selector */}
              <div className="mp-limit">
                <span>Show</span>
                <select
                  value={limit}
                  onChange={(e) => setLimit(e.target.value)}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>

              {/* Navigation */}
              <div className="mp-controls">
                <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                  Prev
                </button>

                <div className="mp-info">
                  Page <strong>{pagination.page}</strong> of{" "}
                  <strong>{pagination.totalPages}</strong>
                </div>

                <button
                  disabled={page === pagination.totalPages}
                  onClick={() => setPage(page + 1)}
                >
                  Next
                </button>
              </div>

              {/* Jump to Page */}
              <div className="mp-jump">
                <select value={page} onChange={(e) => setPage(e.target.value)}>
                  {Array.from({ length: pagination.totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default BalanceHistory;
